import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Radio Button Design Guidelines",
  "title": "Radio Button",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="radio_button" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The Radio button allows the user to select one option from a set.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Use radio buttons when the user needs to see all available options. If available options can be collapsed, consider using a Select component because it uses less space.`}</p>
      <p>{`Radio buttons should have the most commonly used option selected by default.`}</p>
      <undefined><figure>{`
  `}<div parentName="figure" {...{
            "className": "image-container"
          }}>{`
    `}<span parentName="div" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "646px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "71.81467181467181%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPUlEQVQ4y61T2W6EMAzc//+LPvSfUMWyVAHCFQhhTw67GldB3Rbaql1LJofxaOyJd0TEf7W13B0+1+uVq6ri4/HI1lrxvu/ZGMNt2y732Hsfx3EVdAHUOpMfi6JgrTXXdc1pmrJSSsCwz7KM8zyX2DzP24DTRHy7PbDkw2vHT88vwnC/33McxxxFkezBBIlrvslwHIldPy6XABmGgc/n813iGuAqQ+ccp6mSFUI0TcPTNN0B/dYWwCRJRFmIgsZ7Fbd69S0g2Hwsz4Og7M+92uqnjwsgnkEQBLLiyYRhKIwhzuVy+RHoCyAY+sT/GEABSF3XkVKKrLWU5zmVZUnOOarrmqqqkrgxhtq2lbVpGrn3Z601nU4nUKRFFEwE+liWpZSL6cA4QnXE0Q6oD8d7xRkx5PlcKZnei3+Iw94AEDNFtoVWrUgAAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "",
                "title": "",
                "src": "/static/b69dd0891e6fb206c76c7269b3ed7e83/27524/Radio-buttons-example.png",
                "srcSet": ["/static/b69dd0891e6fb206c76c7269b3ed7e83/a2ead/Radio-buttons-example.png 259w", "/static/b69dd0891e6fb206c76c7269b3ed7e83/6b9fd/Radio-buttons-example.png 518w", "/static/b69dd0891e6fb206c76c7269b3ed7e83/27524/Radio-buttons-example.png 646w"],
                "sizes": "(max-width: 646px) 100vw, 646px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Radio buttons`}</p>{`
  `}</figcaption>
        </figure>
        <div {...{
          "className": "two-col"
        }}>{`
  `}<div parentName="div" {...{
            "className": "row"
          }}>{`
    `}<div parentName="div" {...{
              "className": "col col-1"
            }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                  "className": "gatsby-resp-image-wrapper",
                  "style": {
                    "position": "relative",
                    "display": "block",
                    "marginLeft": "auto",
                    "marginRight": "auto",
                    "maxWidth": "600px"
                  }
                }}>{`
      `}<span parentName="span" {...{
                    "className": "gatsby-resp-image-background-image",
                    "style": {
                      "paddingBottom": "50.57915057915058%",
                      "position": "relative",
                      "bottom": "0",
                      "left": "0",
                      "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA20lEQVQoz5VS7QqDMAzc+z/Y2I8xGIMpiND5OXVW6xcq6o10FmTT4gJHaNMcuVwPWMQ0TdgKXY3K85vpsNbQ9z26rsMwDBKqpiHdJqTM2AOGYSIIAnieJ8lV7RuK6Idw2fBPKK7VCRXZ9fbC3eRomgpZloFzjqqqkCQJoihCmqYoikI/4ZLweHrifEkgBEcYhhJxHMN1Xfi+LzOdd0n+xDhjl1y9KeM4wrZtOI4jTWGMSWNoSsuy5JkghFgq00umHdHuyF3aVV3XKMtS3lHO8xxt2+pN2fF5d0l+A97tEHkdyJrMAAAAAElFTkSuQmCC')",
                      "backgroundSize": "cover",
                      "display": "block"
                    }
                  }}></span>{`
  `}<img parentName="span" {...{
                    "className": "gatsby-resp-image-image",
                    "alt": "",
                    "title": "",
                    "src": "/static/ccf67e99a7c8040d7a2348be01375d15/0a47e/Radio-select-only-one.png",
                    "srcSet": ["/static/ccf67e99a7c8040d7a2348be01375d15/a2ead/Radio-select-only-one.png 259w", "/static/ccf67e99a7c8040d7a2348be01375d15/6b9fd/Radio-select-only-one.png 518w", "/static/ccf67e99a7c8040d7a2348be01375d15/0a47e/Radio-select-only-one.png 600w"],
                    "sizes": "(max-width: 600px) 100vw, 600px",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    },
                    "loading": "lazy"
                  }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                    "className": "title title-correct"
                  }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            Use radio buttons when only one item can be selected from a list.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
              "className": "col col-2"
            }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                  "className": "gatsby-resp-image-wrapper",
                  "style": {
                    "position": "relative",
                    "display": "block",
                    "marginLeft": "auto",
                    "marginRight": "auto",
                    "maxWidth": "600px"
                  }
                }}>{`
      `}<span parentName="span" {...{
                    "className": "gatsby-resp-image-background-image",
                    "style": {
                      "paddingBottom": "50.57915057915058%",
                      "position": "relative",
                      "bottom": "0",
                      "left": "0",
                      "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAx0lEQVQoz51R2QqDMBD0/79Q9EWNt3grqGimzNIUaTVIA8uybDKZw8HpaK1xd2w7rt93tHP1YNs2rOuKfd+lzM4Ceg/IHoYhXNdFmqaI41jAze67DNAP4ANZNivuGR7HIczKssQ4jmjbFk3TYJomVFWFoihQ1zWGYbAzPAMGQSBS+TDPc2RZJh8opZAkiXTOjyUzFNZDuXbJTNXzPERRJNINW7L0fV9mVt/356DsKdMr+sZ06dU8zx8/2buuw7Is9lD+SflK8guV9BDT7l+2rAAAAABJRU5ErkJggg==')",
                      "backgroundSize": "cover",
                      "display": "block"
                    }
                  }}></span>{`
  `}<img parentName="span" {...{
                    "className": "gatsby-resp-image-image",
                    "alt": "",
                    "title": "",
                    "src": "/static/4a02fd6e20dc2057a915c3ec85251d6e/0a47e/Radio-select-only-one-incorrect.png",
                    "srcSet": ["/static/4a02fd6e20dc2057a915c3ec85251d6e/a2ead/Radio-select-only-one-incorrect.png 259w", "/static/4a02fd6e20dc2057a915c3ec85251d6e/6b9fd/Radio-select-only-one-incorrect.png 518w", "/static/4a02fd6e20dc2057a915c3ec85251d6e/0a47e/Radio-select-only-one-incorrect.png 600w"],
                    "sizes": "(max-width: 600px) 100vw, 600px",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    },
                    "loading": "lazy"
                  }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                    "className": "title title-incorrect"
                  }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Don’t use checkboxes when only one item can be selected from a list.
            Use radio buttons instead.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
        </div>
        <figure>{`
  `}<div parentName="figure" {...{
            "className": "image-container"
          }}>{`
    `}<span parentName="div" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "600px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "77.22007722007721%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAABMElEQVQ4y62SjW6CMBSFff83WmKyt0CCaAMEkb+WIEZAuGe5xbKauU3mmtxQaPv1HO5ZAQAR4cVBNwatDOx0OsF1XcRxjDzPkSQJoihClmUQQuh5GIa6giCA7/vwPA/7/R7n85kMdQYOw4C+79G2La7XKy6XC29E13XznNdM8XvTNHptlmcDGVaWpQYbyEuWpZTaMkPZHlthBeYf/1KfCu2mjGP76OqnFH6xLGWLtzU3pMbxmCDLctR1fadwEVBVLdbvB5SygVIS262PoiiWA6fJ9HUc/tFyWUo4mw2S5Khzx3nj+PzZMh+uqmqODedsgcrHOVRKaRiXCbet8lkgv5CUkjzPozRNabfbkRCCHMchpRTd9tLt4Hd1H2x+2janXI5LGjN3+e52e9hrPym0xwcxbJlRXBH5egAAAABJRU5ErkJggg==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "",
                "title": "",
                "src": "/static/9b9ea23e8cf927093327fa75c5cfa41f/0a47e/Radio-example-2.png",
                "srcSet": ["/static/9b9ea23e8cf927093327fa75c5cfa41f/a2ead/Radio-example-2.png 259w", "/static/9b9ea23e8cf927093327fa75c5cfa41f/6b9fd/Radio-example-2.png 518w", "/static/9b9ea23e8cf927093327fa75c5cfa41f/0a47e/Radio-example-2.png 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Radio buttons - only one option can be selected at a time.`}</p>{`
  `}</figcaption>
        </figure></undefined>
      <h2>{`States`}</h2>
      <p>{`Radio buttons can be off or on. Radio buttons have enabled, focused and pressed states.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.09266409266408%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/klEQVQ4y6WR3WqEMBBG9/2fpBd9gF7tbXtVSrG04q5g1mjVgkFNzI/xK6br0i0b0BoIw2QmhznMDjfOOI5Y+T4Xxp3vkzEGTdO4XGvtch90EbAsS0RRhKqqEAQBGGPbgMNg0HXsCrBJue003t4ZlJrAHay1l/rc8yv6gdb+1Mipxd39AdVXg/h4gFL6f8Br7duKf/UXKYu+R13XTjdNUxRFgTzPXeScL5/wMp1WUIJDyd6BJmiWZaCUQgixHli2CgGt0chhm/K8lKePBA+PL3iOCChJkBCCOI4RhiGklCu2fK5Fnwz71yMyxmGNhhC9U53uqi2fW1zU/iV7lb8BmRn+im/Kv6cAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/cfcfc39f4743dc463ee5dc348d48be5c/0a47e/Radio-states.png",
              "srcSet": ["/static/cfcfc39f4743dc463ee5dc348d48be5c/a2ead/Radio-states.png 259w", "/static/cfcfc39f4743dc463ee5dc348d48be5c/6b9fd/Radio-states.png 518w", "/static/cfcfc39f4743dc463ee5dc348d48be5c/0a47e/Radio-states.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Radio states`}</p>{`
  `}</figcaption>
      </figure>
      <h2>{`Inverse`}</h2>
      <p>{`Use the inverse version when using the radio buttons on a dark background.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.09266409266408%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABZ0lEQVQ4y52Ty07CQBSGeRQRtVzbcqkgBhERq1WrES/BRFfsXVZaahEiCXcj8RZXrnwCX4/fzAEUxCh1cfJ3Znq+Of+cGYdHKGI03LzxqQt+nZQLGGPz33M8gtEbfPcck4v9JH/oCtHEDbxiEXzYovHPsCmA874CVjN1HJzcI7leQ+78GfFklSr+F5BV4guakJYrNGaWWfzbMquEwY5OHyFIJUTiFdpgFDYO/gXIzszluYS820a1/o6VdA1qtgshYhGErdsCDn9kFllVrFqnW6NN5rwFikn7f1hmCeJiibocWSpD3mljTW4gvdlESm7Q3BA6dVMCIRNByYIoWUhvNQmaUVrY2G4hFLu2B+T8OsKJKlJqF3y0jFlOg5PTMDNQW5a9ogmXW8P+2QvyF29Qc09Q1A6UvVuo2Tsc5h7oOLiAbu9iJ5UOjvOviKZqZJ/ZDMfKpPa6zJQ3+iqag7esU7eHMfmuv4AftO/lBYU0KLoAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/04a3eda4314f1cc6c9f408909613a78a/0a47e/Radio-inverse.png",
              "srcSet": ["/static/04a3eda4314f1cc6c9f408909613a78a/a2ead/Radio-inverse.png 259w", "/static/04a3eda4314f1cc6c9f408909613a78a/6b9fd/Radio-inverse.png 518w", "/static/04a3eda4314f1cc6c9f408909613a78a/0a47e/Radio-inverse.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Inverse colors`}</p>{`
  `}</figcaption>
      </figure>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      